<template>
    <div class="modalwrapper">
        <h1>Load/Import workflow</h1>
        <WorkflowSelector v-model="selectedWorkflow"/>
        <br>
        <button :disabled="!selectedWorkflow" @click="loadWorkflowAndSwitch">Load</button>
        <br><br>
        <div class="dropzone" @drop="dropHandler($event)" v-on:dragover="$event.preventDefault()">
            <div>Drop workflow file here</div>
        </div>
        <br>
        <button @click="$refs.upload.click()">Choose file</button>
        <br>
        <input type="file" ref="upload" hidden @change="selectHandler($event)">
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import WorkflowSelector from './WorkflowSelector';

export default {

    methods: {
        selectHandler(evt) {
            const files = evt.target.files; // FileList object

            for(let i = 0; i < files.length; i++){
                this.handleFile(files[i]);
            }
        },
        addTag(newTag){
            this.$store.state.projects.push(newTag);
            this.selectedProject = newTag;
        },
        dropHandler(ev) {
            console.log('File(s) dropped');

            // Prevent default behavior (Prevent file from being opened)
            ev.preventDefault();

            if (ev.dataTransfer.items) {
                // Use DataTransferItemList interface to access the file(s)
                for (var i = 0; i < ev.dataTransfer.items.length; i++) {
                    // If dropped items aren't files, reject them
                    if (ev.dataTransfer.items[i].kind === 'file') {
                        var file = ev.dataTransfer.items[i].getAsFile();
                        console.log('... file[' + i + '].name = ' + file.name);
                        this.handleFile(file);
                    }
                }
            } else {
                // Use DataTransfer interface to access the file(s)
                for (var i = 0; i < ev.dataTransfer.files.length; i++) {
                    console.log('... file[' + i + '].name = ' + ev.dataTransfer.files[i].name);
                    this.handleFile(ev.dataTransfer.files[i]);
                }
            } 

            // Pass event to removeDragData for cleanup
            this.removeDragData(ev)
        },
        handleFile(file){
            console.log('handleFile', file)
            const reader = new FileReader();
            reader.onload = (event)=>{
                console.log(event.target);
                this.importWorkflow(event.target.result);
                this.$emit('close');
                this.$router.push('/workflow');
            };
            reader.readAsText(file);
        },
        removeDragData(ev) {
            console.log('Removing drag data');

            if (ev.dataTransfer.items) {
                // Use DataTransferItemList interface to remove the drag data
                ev.dataTransfer.items.clear();
            } else {
                // Use DataTransfer interface to remove the drag data
                ev.dataTransfer.clearData();
            }
        },
        ...mapActions([
            'loadWorkflow',
            'importWorkflow'
        ]),
        loadWorkflowAndSwitch(){
            this.loadWorkflow(this.selectedWorkflow);
            this.$emit('close');
            this.$router.push('/workflow');
        },
    },
    components: {
        WorkflowSelector,
    },
    mounted(){
    },
    props: [
        'close'
    ],
    data: function(){
        return {
            selectedProject: null,
            selectedWorkflow: null,
        }
    }
}

</script>

<style lang="scss" scoped>
    @import "../colors.scss";
    ::v-deep .dropzone {
        width: 100%;
        height: 160px;
        border: 1px dashed $accromagrey;
        text-align: center;
        div {
            padding-top: 65px;
        }
    }
    .modalwrapper {
        padding: 10px;
    }
    .padding {
        padding-bottom: 10px;
    }
    .con {
        padding: 10px;
    }


    button {
            &:not(.vue-treeselect__input){
                box-shadow: 2px 2px 5px 0px $accromagrey;
                /*transition: transform 0.1s linear;
                transition: box-shadow 0.1s linear;
                &:hover {
                    transform: translate(1px, 1px);
                    box-shadow: 2px 2px 1px 0px $accromagrey !important;
                }*/
            }
        }
        input {
            &:not(.vue-treeselect__input){
                background-color: #eee;
            }
        }

        button:hover {
            &:not(.vue-treeselect__input):not([disabled]){
                background-color: $accromabluehue;
            }
        }

        input, textarea, select {
            &:not(.vue-treeselect__input):focus {
                outline-color: $accromablue;
                outline-style: auto;
                outline-width: 3px;
            }
        }
        button:focus {
            outline: none;
        }
        button, input, textarea, select {
            &:disabled {
                background-color: rgba(255,255,255,0.7);
            }
        }
</style>
